
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const bankAccountsApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getBankAccounts: build.query<any, void>({
      query: () => ({
        url: appEndpoint.bankAccounts,
        method: 'get',
      }),
      providesTags: ['BankAccounts'],
    }),
    addBankAccount: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.bankAccounts,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["BankAccounts"] : []),
    }),

    updateBankAccount: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.bankAccounts}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["BankAccounts"] : []),
    }),
    

    deleteBankAccount: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.bankAccounts}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['BankAccounts'],
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetBankAccountsQuery,
  useAddBankAccountMutation,
  useUpdateBankAccountMutation,
  useDeleteBankAccountMutation,
} = bankAccountsApi;